export default "__VITE_ASSET__CYR1vJVf__"